import { memo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import _startCase from 'lodash/startCase';
import _format from 'date-fns/format';
//Local files
import { urgentlyAdditionalCostStatuses } from 'helpers/constants';

const UrgentlyAdditionalCostsTable = ({ 
  orderId, 
  costs, 
  disabled, 
  isShowMore, 
  onNextOffset 
}) => {
  const getStatusColor = (status) => {
    switch (status) {
      case urgentlyAdditionalCostStatuses.PENDING:
        return 'default';
      case urgentlyAdditionalCostStatuses.SUBMITTED:
        return 'info';
      case urgentlyAdditionalCostStatuses.APPROVED:
        return 'success';
      case urgentlyAdditionalCostStatuses.DECLINED:
        return 'error';
      case urgentlyAdditionalCostStatuses.FAILED:
        return 'warning';
      default:
        return 'default';
    }
  };

  if (!costs.length) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          No additional costs found
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Type</TableCell>
              <TableCell>Price</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Originator</TableCell>
              <TableCell>Minutes</TableCell>
              <TableCell>Created</TableCell>
              <TableCell>Notes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {costs.map((cost) => (
              <TableRow key={cost.id}>
                <TableCell>
                  <Typography variant="body2">
                    {cost.formatted_cost_type || _startCase(cost.cost_type)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">
                    ${cost.price}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={_startCase(cost.status)}
                    color={getStatusColor(cost.status)}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {_startCase(cost.originator)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {cost.minutes || '-'}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {_format(new Date(cost.created_at), 'MMM dd, yyyy HH:mm')}
                  </Typography>
                </TableCell>
                <TableCell>
                  {cost.notes && (
                    <Typography variant="body2" sx={{ mb: cost.decline_reason ? 0.5 : 0 }}>
                      {cost.notes}
                    </Typography>
                  )}
                  {cost.decline_reason && (
                    <Typography variant="caption" color="error" sx={{ display: 'block' }}>
                      Declined: {cost.decline_reason}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      {isShowMore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button 
            variant="outlined" 
            onClick={onNextOffset}
            disabled={disabled}
          >
            Load More
          </Button>
        </Box>
      )}
    </>
  );
};

export default memo(UrgentlyAdditionalCostsTable);
